import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@shared/ui/table";
import { KeyRound } from "lucide-react";
import { FormattedMessage } from "react-intl";

const recentUsers = [
	{ email: "anna@acme.io", provider: "Google", status: "Active", joined: "2m ago" },
	{ email: "marco@studio.dev", provider: "Email", status: "Active", joined: "14m ago" },
	{ email: "lena@northwind.co", provider: "GitHub", status: "Pending", joined: "1h ago" },
	{ email: "ravi@umbra.xyz", provider: "Email", status: "Active", joined: "3h ago" },
	{ email: "sofia@pixel.app", provider: "Google", status: "Banned", joined: "yesterday" },
];

export function RecentUsers() {
	return (
		<Card className="lg:col-span-2">
			<CardHeader>
				<CardTitle className="flex items-center gap-2">
					<KeyRound className="h-4 w-4 text-muted-foreground" />
					<FormattedMessage id="dashboard.recentUsers.title" defaultMessage="Recent users" />
				</CardTitle>
				<CardDescription>
					<FormattedMessage
						id="dashboard.recentUsers.description"
						defaultMessage="Latest sign-ups via auth providers"
					/>
				</CardDescription>
			</CardHeader>
			<CardContent>
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>
								<FormattedMessage
									id="dashboard.recentUsers.column.email"
									defaultMessage="Email"
								/>
							</TableHead>
							<TableHead>
								<FormattedMessage
									id="dashboard.recentUsers.column.provider"
									defaultMessage="Provider"
								/>
							</TableHead>
							<TableHead>
								<FormattedMessage
									id="dashboard.recentUsers.column.status"
									defaultMessage="Status"
								/>
							</TableHead>
							<TableHead className="text-right">
								<FormattedMessage
									id="dashboard.recentUsers.column.joined"
									defaultMessage="Joined"
								/>
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{recentUsers.map((u) => (
							<TableRow key={u.email}>
								<TableCell className="font-medium">{u.email}</TableCell>
								<TableCell className="text-muted-foreground">{u.provider}</TableCell>
								<TableCell>
									<Badge
										variant={
											u.status === "Active"
												? "default"
												: u.status === "Pending"
													? "secondary"
													: "destructive"
										}
									>
										{u.status}
									</Badge>
								</TableCell>
								<TableCell className="text-right text-muted-foreground">{u.joined}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
}
